export const getRSAPublicKey = () => process.env.REACT_APP_RSA_PUBLIC_KEY
